export enum TradePosition {
	Long = 'long',
	Short = 'short',
}

export const TradePositions: TradePosition[] = Object.values(TradePosition) as TradePosition[];
